import EventsHandler from "../service/events";
import {AnimationService} from "../service/animation";
import OpenAccordion from "../animations/open-accordion";
import CloseAccordion from "../animations/close-accordion";

export class AccordionComponent
{
    private $root:JQuery;
    private $items:JQuery;
    private events:EventsHandler;
    private animations:AnimationService;

    constructor(element:HTMLElement) {
        this.$root = $(element);
        this.$items = $(element).find('.js-accordion__item');
    }

    protected init() {
        this.$root
            .find('.js-accordion__toggle')
            .on({ click: this.toggleAccordion });
        // this.$root.find('.js-accordion__toggle').on('click', this.handleAccordionOpen);
        // this.events.addListener(EVENTS.MENU_CLOSE, this.handleAccordionClose);
    }

    protected toggleAccordion = (ev:MouseEvent) => {
        let $target = $(ev.currentTarget).closest('.js-accordion__item');
        if ('true' === $target.attr('aria-expanded')) {
            this.handleAccordionClose($target);
        } else {
            this.handleAccordionOpen($target);
        }
    }

    protected handleAccordionOpen = ($target:JQuery<any>) => {
        this.handleAccordionClose(this.$items.filter('[aria-expanded="true"]'));
        let $content = $target.find('.js-accordion__content');
        if ($content.length) {
            $target.attr('aria-expanded', 'true')
            this.animations.run(OpenAccordion, $content);
        }
    }

    protected handleAccordionClose = ($target:JQuery<any>) => {
        let $content = $target.find('.js-accordion__content');
        if ($content.length) {
            $target.attr('aria-expanded', 'false')
            this.animations.run(CloseAccordion, $content);
        }
    }

    public setEventHandler(events:EventsHandler) {
        this.events = events;
        return this;
    }

    public setAnimationHandler(animations:AnimationService) {
        this.animations = animations;
        return this;
    }
}